import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteInvoiceRequestForm', {
    toolbarText: 'Invoice Details',
    mandatoryFieldsError: 'Please fill all mandatory fields.',
    exchangeRateError:
        'Exchange rate is missing. Either retry loading exchange rates from NetSuite or enter manual exchange rate.',
    invalidDiscountRateError: 'Invalid number or percentage',
    emptyDiscountItemError: 'Please select a discount item or delete discount rate',
});
